:host {
  display: block;
}

#chat-container {
  position: relative;
  background-color: $color-blue-6;
  padding: 30px;
  max-height: var(--ux-chat-height, 500px); // Restrict the height of the chat container
  overflow-y: auto; // Ensure the scrollbar is always visible
  display: flex;
  flex-direction: column-reverse;
  overflow-anchor: auto !important;
}

#items {
  display: flex;
  flex-direction: column;
  gap: 10px 5px;
  transform: translateZ(0); /* fixes a bug in Safari iOS where the scroller doesn't update */
}

#chat-bar {
  margin-top: 10px;
  background-color: $color-white;
  flex-shrink: 0;
  box-sizing: border-box;
}

::slotted(ux-chat-item[source="user"]) {
  margin-bottom: 0;
  align-self: flex-end;
}
